import React from 'react';
import Social from '../Social/Social';
import { withNamespaces } from 'react-i18next';
import Project from '../Project';
import { portfolioWorks as worksArr } from './../../App';

const Projects: React.FC = ({ t }: any) => {
  return (
    <>
      <div className="projects">
        <div className="projects__container">
          <h3>{t('portfolio_title')}</h3>
          <div className="projects__wrap">
            {worksArr.map((item, index) => (
              <Project key={index} {...item} />
            ))}
          </div>

          <div className="projects__bttn-wrap">
            <a
              className="projects-bttn bttn"
              href="https://github.com/agentdmitro?tab=repositories">
              {t('gh-page_link')}
            </a>
          </div>
        </div>
      </div>
      <Social />
    </>
  );
};
export default withNamespaces()(Projects);
